import { FC } from 'react';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';

interface LoaderProps {
  className?: string;
  size?: 'small' | 'normal';
}

const Loader: FC<LoaderProps> = ({ className, size = 'normal' }) => {
  const classes = useStyles();

  const sizes = {
    small: 20,
    normal: 40,
  };

  return (
    <div className={clsx(classes.root, className)}>
      <CircularProgress size={sizes[size]} />
    </div>
  );
};

export default Loader;
